import { Modal, Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCasperIdAttachments, uploadDocument } from '../../features/Certificate/CertificateSlice'; // Import the thunk action
import ArrowRightOutlined from '../../assets/icons/rawdata/Modal_arrow.svg';
import icon1 from '../../assets/icons/rawdata/house 1.svg';
import icon2 from '../../assets/icons/rawdata/warehouse 1.svg';
import icon3 from '../../assets/icons/rawdata/clarity_factory-solid.svg';
import icon4 from '../../assets/icons/rawdata/petroleum 1.svg';
import icon5 from '../../assets/icons/rawdata/shipping 1.svg';
import CertificateDetails from '../../components/CertificateDetails';

const CertificationModal = ({ isModalVisible, handleCancel , casperId, imoNumber, isCertificationModalVisible, setIsCertificationModalVisible }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fileMap, setFileMap] = useState({});
  
  const dispatch = useDispatch();
  
  const { casperData } = useSelector((state) => state.certificate)
  useEffect(() => {
    if (isModalVisible && casperId && imoNumber) {
      dispatch(fetchCasperIdAttachments({ imoNumber, casperId }));
    }
  }, [isModalVisible, casperId, imoNumber, dispatch]);

  const dynamicData = [
    {
      id: '9232060',
      description: 'Add the required documents for each stage.',
      filesAdded: `${casperData?.feedstock_poo_urls?.length || 0} Files added`,
      icon: icon1,
      heading: 'Sustainability Declaration', 
      subheading: '(Feedstock/Point of Origin)',
      requested: 'feedstock_poo_urls'
    },
    {
      id: '9232061',
      description: 'Provide all necessary files for the inspection.',
      filesAdded: `${casperData?.first_gathering_point_urls?.length || 0} Files added`,
      icon: icon2,
      heading: 'Sustainability Declaration',
      subheading: '(First gathering/Collection point)',
      requested: 'first_gathering_point_urls'
    },
    {
      id: '9232062',
      description: 'Submit all relevant certification documents.',
      filesAdded: `${casperData?.trader_urls?.length || 0} Files added`,
      icon: icon3,
      heading: 'Fuel Specifications',
      subheading: '(Bunker Delivery Note)',
      requested: 'trader_urls'
    },
    {
      id: '9232063',
      description: 'Upload all required data for transportation.',
      filesAdded: `${casperData?.prod_to_bunkering_urls?.length || 0} Files added`,
      icon: icon4,
      heading: 'Proof of Sustainability',
      subheading: '(Production to Bunkering)',
      requested: 'prod_to_bunkering_urls'
    },
    {
      id: '9232064',
      description: 'Complete all documentation for final delivery.',
      filesAdded: `${casperData?.bunkering_to_usage_urls?.length || 0} Files added`,
      icon: icon5,
      heading: 'Proof of Compliance',
      subheading: '(Bunkering to Usage)',
      requested: 'bunkering_to_usage_urls'
    },
    {
      id: '9232065',
      description: 'Complete all documentation for final delivery.',
      filesAdded: `${casperData?.verified_emission_statement_url ? 1 : 0} Files added`,
      icon: icon5,
      heading: 'Verified Emission Statement',
      subheading: '(EUA and FEUM Statement)',
      requested: 'verified_emission_statement_url'
    }
  ];



  const activeData = dynamicData[activeIndex];

  const onSave = () => {
    // You can access files to upload from fileMap here
    // const filesToUpload = fileMap[activeData.heading] || [];

    // // Prepare payload for uploadDocument
    // const payload = {
    //   files: filesToUpload.filter(file => file.file), // Only include files with a `file` object
    //   casper_id: casperData.casper_id,
    //   imo_number: casperData.imo_number_id,
    // };

    // // Dispatch the uploadDocument action
    // dispatch(uploadDocument(payload));
  };

  const handleClose = () => {
    setIsCertificationModalVisible(false);
    setFileMap([])
  };


  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', color: 'black' }}>
          Add required documentations (Casper ID : {casperId})
        </div>
      }
      visible={isModalVisible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose} style={{ backgroundColor: '#E2E2E2' }}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={onSave} style={{ backgroundColor: '#678DFF', color: 'white' }}>
          Save
        </Button>,
      ]}
      width={800}
    >
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1, height:'500px', overflow:'auto' }}>
          {/* <div style={{ color: '#737373' }}>
            {activeData.description}
          </div> */}
          {dynamicData.map((item, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => setActiveIndex(index)}
              style={{
                marginTop: '10px',
                borderRadius: '8px',
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
                background: hoveredIndex === index ? '#E6F7FF' : (activeIndex === index ? '#EFF5FF' : 'none'),
                height: '80px',
                border: hoveredIndex === index ? 'none' : (activeIndex === index ? 'none' : '1px solid #005BF3'),
                cursor: 'pointer'
              }}
            >
              <img src={item.icon} alt="icon" style={{ marginRight: '10px', width: '40px', height: '40px' }} />
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', color: '#005BF3' }}>
                  <span>{item.heading}</span>
                  <img
                    src={ArrowRightOutlined}
                    alt="arrow icon"
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                  />
                </div>
                <div style={{ color: '#005BF3' }}>{item.subheading}</div>
                <div style={{ color: '#272727', opacity: '0.5' }}>{item.filesAdded}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginLeft: '20px', width: '380px' }}>
          <CertificateDetails
            heading={activeData.heading}
            subheading={activeData.subheading}
            files={fileMap[activeData.heading] || []}
            handleCancel={handleClose}
            isCertificationModalVisible={isCertificationModalVisible}
            casperId={casperId}
            imoNumber={imoNumber}
            requestedEntity={activeData.requested}
          />
        </div>
      </div>
    </Modal>
  );
}

export default CertificationModal;
